import { useRequest } from 'ahooks'
import { AxiosRequestConfig } from 'axios'
import { Atom, useAtom } from 'jotai'
import React from 'react'

export const useAxiosWithAtom = <T>(atom: Atom<T>, params: AxiosRequestConfig) => {
  const [data, setData] = useAtom<T>(atom)
  const res = useRequest(params, {
    refreshOnWindowFocus: false,
  })
  React.useEffect(() => {
    if (res.data) {
      ;(setData as any)(res.data)
    }
  }, [res.data])
  return { ...res, data }
}
